import { Button } from "@mantine/core";
import { useState } from "react";
import ReactDOM from "react-dom";

interface ContractFormControlsProps {
  buttonContainer?: HTMLElement;
  onCancel: () => void;
  onSubmit: () => Promise<void>;
}

function ContractFormControls({
  buttonContainer,
  onCancel,
  onSubmit
}: ContractFormControlsProps) {
  const [isSubmitting, setIsSubmitting] = useState(false);

  async function handleClickSubmit() {
    setIsSubmitting(true);

    try {
      await onSubmit();
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <div className="ContractFormControls">
      {buttonContainer &&
        ReactDOM.createPortal(
          <>
            <Button
              color="secondary"
              loading={isSubmitting}
              onClick={handleClickSubmit}
            >
              Speichern
            </Button>
            <Button variant="default" onClick={onCancel}>
              Abbrechen
            </Button>
          </>,
          buttonContainer
        )}
    </div>
  );
}

export { ContractFormControls, ContractFormControlsProps };
